import ModalFileBeneficiaries from "./ModalFileBeneficiaries.js";
export default ModalFileBeneficiaries;
